import script from "./IndexTopTitleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexTopTitleComponent.vue?vue&type=script&setup=true&lang=js"

import "./IndexTopTitleComponent.vue?vue&type=style&index=0&id=12d051e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d051e1"]])

export default __exports__